
export const printParameterTranslation = Object.freeze({
  PRODUCT_DEFINITION: 'Product name',
  CUSTOMER_TYPE: 'Customer type',
  OPERATION_SIDE: 'Operation side',
  COMMAND: 'Operation',
  LETTER_TYPE: 'Letter type',
  LETTER_BORROWER_TYPE: 'Borrower type'
});
